import { InventoryEntryStateEnums, InventoryEntryTypeEnums } from 'src/app/enum/inventory-entry-enums';

export class InventoryEntryModel {
  inventoryEntryId: number = 0;
  inventoryId: number = 0;
  branchId: number = 0;
  inventoryEntryTypeId: number = InventoryEntryTypeEnums.entry;
  consecutive: number = 0;
  dateEntry: Date = new Date;
  inventoryPeriodId: number = 0;
  inventoryEntryStateId: number = InventoryEntryStateEnums.open;
  conceptId: number = 0;
  providerId: number = 0;
  remission: string | null = null;
  invoice: string | null = null;
  observation: string | null = null;
  totalValue: number = 0;
  swRequirePurchaseOrder: boolean = false;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}
